import React from "react";

export default function BottomNav({ tabs, active, onChange }) {
  return (
    <nav className="fixed bottom-0 inset-x-0 z-40">
      <div className="max-w-md mx-auto bg-white border-t border-slate-200 px-2 py-2 flex justify-around shadow-[0_-4px_20px_rgba(0,0,0,0.05)]">
        {tabs.map((t) => {
          const A = active === t.key;
          const I = t.icon;
          return (
            <button
              key={t.key}
              data-testid={`nav-${t.key}`}
              onClick={() => onChange(t.key)}
              className="flex flex-col items-center gap-0.5 px-2 py-1 rounded-xl transition-colors"
            >
              <I className={`h-5 w-5 ${A ? "text-primary" : "text-slate-400"}`} />
              <span className={`text-[11px] font-semibold font-display ${A ? "text-primary" : "text-slate-400"}`}>{t.hi}</span>
              <span className={`text-[9px] ${A ? "text-primary/70" : "text-slate-300"}`}>{t.en}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
